import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AppLayout from "@/components/AppLayout";
import { useAuth } from "@/lib/auth";
import ClientProfileTab from "@/components/ClientProfileTab";
import { Buildings } from "@phosphor-icons/react";

export default function ClientProfilePage() {
  const { user } = useAuth();
  const [company, setCompany] = useState(null);

  useEffect(() => {
    if (!user?.company_id) return;
    api.get(`/companies/${user.company_id}`).then((r) => setCompany(r.data));
  }, [user]);

  const header = (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight flex items-center gap-2" style={{ fontFamily: "Geist" }}>
        <Buildings size={22} /> Company Profile
      </h1>
      <p className="text-sm text-slate-500 mt-0.5">Your company information and document library (read-only).</p>
    </div>
  );

  return (
    <AppLayout header={header}>
      {company ? (
        <ClientProfileTab company={company} role="client" />
      ) : (
        <div className="text-sm text-slate-500">Loading...</div>
      )}
    </AppLayout>
  );
}
